var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("ご利用ガイド")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "guide_section" }, [
                _c("div", { staticClass: "guide_msg" }, [
                  _vm._v(
                    "\n            HAKOTANは、1mm単位でサイズオーダーできる収納家具を簡単にオーダーいただけます。\n            ご購入のご案内として、採寸方法から商品のカスタマイズ、ご注文完了までの流れをご確認ください。\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "guide_area" }, [
                  _c("div", { staticClass: "guide_title" }, [
                    _vm._v("購入までの流れ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide_flow" }, [
                    _c("div", { staticClass: "guide_sp_flow" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "guide_flow_item" }, [
                          _c("div", { staticClass: "guide_flow_icon" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getImage("guide/icon_measure.png")
                              }
                            })
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_flow_line sp_hide" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_sp_flow" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "guide_flow_item" }, [
                          _c("div", { staticClass: "guide_flow_icon" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getImage("guide/icon_customize.png")
                              }
                            })
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_flow_line sp_hide" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_sp_flow" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "guide_flow_item" }, [
                          _c("div", { staticClass: "guide_flow_icon" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getImage("guide/icon_price.png")
                              }
                            })
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_flow_line sp_hide" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_sp_flow" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "guide_flow_item" }, [
                          _c("div", { staticClass: "guide_flow_icon" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getImage("guide/icon_completed.png")
                              }
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("section", [
                _c("div", [
                  _c("div", { staticClass: "guide_main" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_step_msg" }, [
                      _c("div", { staticClass: "step_title" }, [
                        _vm._v("設置場所を採寸")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_text" }, [
                        _vm._v("① 採寸の準備")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_msg step_space1" }, [
                        _vm._v(
                          "\n                  採寸をするにはメジャー準備してください。 また、採寸する際は、垂直・水平に測る必要があります。\n                  二人以上での採寸で、より正確に測定ができます。\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_text" }, [
                        _vm._v("② 設置場所を測る")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_msg step_space2" }, [
                        _vm._v(
                          "\n                  壁から壁まで、または天井から床まで、ピッタリと収まるサイズでオーダーしたい場合は、設置場所の幅・高さ・奥行きを採寸してください。\n                  壁、床は歪んでいる場合がありますので、最も短い寸法を割り出すために複数箇所を採寸してください。\n                  巾木・コンセント．火災報知器などがある場合は、その内側から採寸してください。\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_area" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { staticClass: "step_area_msg" }, [
                          _vm._v(
                            "\n                    設置場所の上下2カ所以上を水平に測り最も短い寸法を実寸とします。巾木がある場合は、その内側から採寸してください。\n                    （例）①245㎜ ②244㎜ ③246㎜ → 実寸は244㎜\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "step_item_area" }, [
                          _c("div", { staticClass: "area_item" }, [
                            _c("div", { staticClass: "area_item_title" }, [
                              _vm._v("カウンター下など")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImage(
                                    "guide/guide_1-2_width_1.png"
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_msg" }, [
                              _vm._v(
                                "3箇所採寸して最も短い寸法を実寸とします。"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "area_item", attrs: { div: "" } },
                            [
                              _c("div", { staticClass: "area_item_title" }, [
                                _vm._v("両サイドが挟まれている場合")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "area_item_img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getImage(
                                      "guide/guide_1-2_width_2.png"
                                    )
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "area_item_msg" }, [
                                _vm._v(
                                  "より正確な数値を確認するため上下の計4箇所を採寸しましょう。"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "area_item", attrs: { div: "" } },
                            [
                              _c("div", { staticClass: "area_item_title" }, [
                                _vm._v("壁面など")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "area_item_img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getImage(
                                      "guide/guide_1-2_width_3.png"
                                    )
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "area_item_msg" }, [
                                _vm._v(
                                  "3箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。"
                                )
                              ])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_area" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("div", { staticClass: "step_area_msg" }, [
                          _vm._v(
                            "\n                    設置場所の左右2カ所以上を垂直に測り最も短い寸法を実寸とします。火災報知器などがある場合は、その内側から採寸してください。\n                    （例）①156㎜ ②155㎜ ③154㎜ → 実寸は154㎜\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "step_item_area" }, [
                          _c("div", { staticClass: "area_item" }, [
                            _c("div", { staticClass: "area_item_title" }, [
                              _vm._v("カウンター下など")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImage(
                                    "guide/guide_1-2_height_1.png"
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_msg" }, [
                              _vm._v(
                                "6箇所採寸して最も短い寸法を実寸とします。"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "area_item" }, [
                            _c("div", { staticClass: "area_item_title" }, [
                              _vm._v("壁面など")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImage(
                                    "guide/guide_1-2_height_2.png"
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_msg" }, [
                              _vm._v(
                                "3箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "area_item" }, [
                            _c("div", { staticClass: "area_item_title" }, [
                              _vm._v("窓下")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImage(
                                    "guide/guide_1-2_height_3.png"
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_msg" }, [
                              _vm._v(
                                "2箇所以上を採寸しましょう。 最も小さい寸法を実寸とします。"
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_area_depth" }, [
                        _c("div", { staticClass: "step_sub" }, [
                          _vm._m(7),
                          _vm._v(" "),
                          _c("div", { staticClass: "area_item" }, [
                            _c("div", { staticClass: "area_item_title" }, [
                              _vm._v("カウンター下など")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.getImage(
                                    "guide/guide_1-2_depth_1.png"
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "area_item_msg" }, [
                              _vm._v(
                                "6箇所採寸して最も短い寸法を実寸とします。"
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_area_size" }, [
                        _vm._m(8),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: _vm.getImage("guide/guide_1-3_1.png")
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_special" }, [
                        _c("div", { staticClass: "special_line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "special_title" }, [
                          _vm._v("壁に固定する必要がある家具の場合")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "special_area" }, [
                          _c("div", { staticClass: "special_msg" }, [
                            _vm._v(
                              "\n                      吊戸棚などの、壁に固定する必要がある商品の場合は壁内の「柱」の場所を確認してください。\n                      確認の方法は、壁を数カ所ノックして音で確認します。裏に柱がない場所は音が響き、柱がある場所は短く固い音が鳴ります。\n                      市販の下地センサーなどを使用することで、 より確実に確認することができます。\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "special_img" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getImage("guide/guide_1-3_2.png")
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "special_line" })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide_main" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_step_msg" }, [
                      _c("div", { staticClass: "step_title" }, [
                        _vm._v("カスタマイズ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_msg" }, [
                        _vm._v(
                          "\n                  採寸して決定した商品サイズをもとに商品のカスタマイズをします。それぞれカラーを選べるので、\n                  お部屋の雰囲気に合わせてお好きな組み合わせをお選びください。\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_custom" }, [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getImage("guide/guide_2-1.png") }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_custom" }, [
                        _vm._m(11),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getImage("guide/guide_2-2.png") }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_custom" }, [
                        _vm._m(12),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getImage("guide/guide_2-3.png") }
                          })
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide_main" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _c("div", { staticClass: "guide_step_msg" }, [
                      _c("div", { staticClass: "step_title" }, [
                        _vm._v("価格を確認")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_msg" }, [
                        _vm._v(
                          "\n                  ご選択いただいたサイズ・色・配送先情報により、お見積もり金額が計算されます。\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_price" }, [
                        _vm._m(14),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getImage("guide/guide_3-1.png") }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_price_sub" }, [
                        _c("div", { staticClass: "step_text" }, [
                          _vm._v("② 搬入経路の寸法を確認する")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "step_msg" }, [
                          _vm._v(
                            "\n                    搬入の際に、玄関・室内ドアや階段の幅、マンションのエレベーターのスペースが理由で、\n                    家具を運べないことがあります。見積もり金額の確認画面に梱包サイズを表示しておりますので、\n                    不安な場所は必ず計測ください。\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "step_msg step_route",
                            on: {
                              click: function($event) {
                                _vm.onRouteConfirm()
                              }
                            }
                          },
                          [_c("a", [_vm._v("搬入経路のご確認")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step_price" }, [
                        _vm._m(15),
                        _vm._v(" "),
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.getImage("guide/guide_3-3.png") }
                          })
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(16)
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_sp_step" }, [
      _c("div", { staticClass: "guide_flow_step" }, [_vm._v("Step 1")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_step_item" }, [_vm._v("設置場所を採寸")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_sp_step" }, [
      _c("div", { staticClass: "guide_flow_step" }, [_vm._v("Step 2")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_step_item" }, [_vm._v("カスタマイズ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_sp_step" }, [
      _c("div", { staticClass: "guide_flow_step" }, [_vm._v("Step 3")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_step_item" }, [_vm._v("価格を確認")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_sp_step" }, [
      _c("div", { staticClass: "guide_flow_step" }, [_vm._v("Step 4")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_step_item" }, [_vm._v("注文完了")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide" }, [
      _c("div", { staticClass: "guide_step" }, [_vm._v("Step1")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_line line_hight1" }, [
        _c("div", { staticClass: "line_area1" }),
        _vm._v(" "),
        _c("div", { staticClass: "line_area2" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step_area_title" }, [
      _c("div"),
      _vm._v(" "),
      _c("div", [_vm._v("幅を測る")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step_area_title" }, [
      _c("div"),
      _vm._v(" "),
      _c("div", [_vm._v("高さを測る")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_area_title" }, [
        _c("div"),
        _vm._v(" "),
        _c("div", [_vm._v("奥行を測る")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_area_msg" }, [
        _vm._v(
          "\n                        設置場所の上下2カ所以上を水平に測り最も短い寸法を実寸とします。巾木がある場合は、その内側から採寸してください。\n                        （例）①102㎜ ②100㎜ ③101㎜ → 実寸は100㎜\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [
        _vm._v("③ 家具のサイズを決める")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg step_size_msg" }, [
        _vm._v(
          "\n                      家具のサイズは、設置場所の実寸よりも幅、高さ、奥行き方向にそれぞれ10mm以上小さいサイズに設定してください。"
        ),
        _c("br"),
        _vm._v(
          "\n                      設置場所の測定値の最も短い寸法を基準に家具のサイズを決定してください。"
        ),
        _c("br"),
        _vm._v(
          "\n                      巾木や火災報知器がある場合は、その内側からの寸法となります。扉などがある商品の場合、開いたときに照明、\n                      火災報知器などに当たらない寸法に設定してください。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide" }, [
      _c("div", { staticClass: "guide_step" }, [_vm._v("Step2")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_line line_hight2" }, [
        _c("div", { staticClass: "line_area1" }),
        _vm._v(" "),
        _c("div", { staticClass: "line_area2" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [_vm._v("① 商品を選ぶ")]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg custin_msg" }, [
        _vm._v(
          "\n                      商品カテゴリページの中から商品を選択してください。商品はそれぞれ、デザイン、扉の有無、\n                      選択できるカラー、材料などが異なります。目的にあった商品をお選びください。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [_vm._v("② サイズ、色を選択")]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg custin_msg" }, [
        _vm._v(
          "\n                      商品のカスタマイズページにて、ご希望の商品サイズ・カラーを入力・選択してください。\n                      サイズは１ミリ単位でご指定いただけます。商品によってカスタマイズ可能なサイズが異なります。\n                      お届け先の郵便番号をご入力することで、配送料金が計算されます。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [
        _vm._v("③ 組立設置サービスを選択")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg custin_msg" }, [
        _vm._v(
          "\n                      組立設置をプロの業者に依頼することもできます。ご依頼される場合は「組立設置サービスの選択」にて\n                      「あり」を選択してください。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide" }, [
      _c("div", { staticClass: "guide_step" }, [_vm._v("Step3")]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_line line_hight3" }, [
        _c("div", { staticClass: "line_area1" }),
        _vm._v(" "),
        _c("div", { staticClass: "line_area2" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [
        _vm._v("① 価格、サイズ、色を確認")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg price_msg" }, [
        _vm._v(
          "\n                      カスタマイズが終了したら、「金額・商品図面を確認する」ボタンをクリックすると、\n                      カスタマイズされた商品の価格・図面が表示されます。\n                      ご確認いただき問題がなければ「カートに追加」をクリックしてください。カートに追加されます。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [_vm._v("③ 注文を確定する")]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg price_msg" }, [
        _vm._v(
          "\n                      搬入経路の問題がないことを確認したら、カート画面の「ご購入手続き」ボタンをクリックしてください。\n                      お届け先情報や、決済情報の入力をして注文を確定してください。\n                      なお、HAKOTANはお客様のオーダーに合わせて一つひとつ製造する商品なので、\n                      キャンセルやご注文後の変更はお受けできません。ご了承ください。\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guide_main" }, [
      _c("div", { staticClass: "guide" }, [
        _c("div", { staticClass: "guide_step step_end" }, [_vm._v("Step4")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "guide_step_msg" }, [
        _c("div", { staticClass: "step_title step_end" }, [_vm._v("注文完了")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ae5c9d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae5c9d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcPaymentGuide.vue
// module id = null
// module chunks = 